import type { WholesaleOptionValue } from '@/models/types';
import { Container, ShoppingCart } from 'lucide-react';
import type { Option } from '../../ui/combobox/combobox-popover';

export type WholesaleOption = Option<WholesaleOptionValue>;

export const getWholesaleOptions = ({
  className,
}: {
  className: string;
}): WholesaleOption[] => {
  return [
    {
      value: 'WHOLESALE',
      label: 'Wholesale',
      icon: <Container className={className} />,
      hotkey: '1',
    },
    {
      value: 'RETAIL',
      label: 'Retail',
      icon: <ShoppingCart className={className} />,
      hotkey: '2',
    },
  ];
};

export const WHOLE_SALE_OPTIONS_MAP = getWholesaleOptions({
  className: 'h-3 w-3',
});
